import { TagGroup } from "../../../shared/models/tagGroup.model.ts";
import { Tags } from "../../../shared/models/tags.model.ts";
import { getToken } from "../../../shared/utils/common.tsx";
import { TagSerializer } from "../serializers/tagSerializer.ts";

export class CommandLinkTemplateToTag {
    async run(templateId: number, tagsLinkedToTemplate: TagGroup[]) {
        const url = `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/content/ads/${templateId}/tags/`
        try {
            const response = await fetch(url, {
                method: "POST",
                headers: {'Content-Type': 'application/json', "Authorization": `Token ${getToken()} `},
                body: JSON.stringify(tagsLinkedToTemplate)
                })
            .then(response =>  response.json())
            .then(json => json)
            .catch(err => console.log(err));
            if(response) {
                // return response;
                return this.deserialize(response);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
            throw error;
        }
    }

    deserialize(data: any): Tags[] {
        const serializer = new TagSerializer();
        return serializer.deserializeList(data);
    }
}
